import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { EmptyStateConfig, TableRow } from '@konnecta/generic-table';

/**
 * The table package translates only the empty-state title (via the labels
 * context); the other three sentences are hardcoded English unless a table
 * passes them in. This is that translation.
 */
export const useTableEmptyState = <T extends TableRow = TableRow>(): EmptyStateConfig<T> => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      description: t('table-no-data-description'),
      filteredTitle: t('table-no-search-results'),
      filteredDescription: t('table-no-search-results-description'),
    }),
    [t]
  );
};
